/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { CheckInBoardingPassByEmailRequest } from '../../models/check-in-boarding-pass-by-email-request';
import { CheckInBoardingPassByEmailResponse } from '../../models/check-in-boarding-pass-by-email-response';
import { ClientId } from '../../models/client-id';

export interface SendBoardingPass$Params {
  orderId: string;
  hash?: string;

/**
 * Session ID in UUID format used to aggregate all the calls for a single customer
 */
  'X-Session-Id'?: string;

/**
 * Client ID representing the caller system
 */
  'X-Client-Id'?: ClientId;

/**
 * W3C Trace Context traceparent header used for distributed tracing
 */
  traceparent?: string;

/**
 * W3C Trace Context tracestate header used for distributed tracing
 */
  tracestate?: string;

/**
 * W3C Baggage header used to propagate contextual key-value pairs
 */
  baggage?: string;
      body: CheckInBoardingPassByEmailRequest
}

export function sendBoardingPass(http: HttpClient, rootUrl: string, params: SendBoardingPass$Params, context?: HttpContext): Observable<DapiHttpResponse<CheckInBoardingPassByEmailResponse>> {
  const rb = new DapiRequestBuilder(rootUrl, sendBoardingPass.PATH, 'post');

  if (params) {
    rb.path('orderId', params.orderId, {});
    rb.query('hash', params.hash, {});
    rb.header('X-Session-Id', params['X-Session-Id'], {});
    rb.header('X-Client-Id', params['X-Client-Id'], {});
    rb.header('traceparent', params.traceparent, {});
    rb.header('tracestate', params.tracestate, {});
    rb.header('baggage', params.baggage, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<CheckInBoardingPassByEmailResponse>;
    }),
    catchErrorAsJson()
  );
}

sendBoardingPass.PATH = '/api/v2/checkin/{orderId}/send-boarding-pass';
